import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  // warningMessage: {
  //   padding: '20px 5px'
  // },
  warningIcon: {
    textAlign: 'center'
  },
  warningFooter: {
    textAlign: 'center',
    maxWidth: '80%',
    margin: '20px auto 0'
  }
})

export default useStyles
